import Vue from 'vue'

/**
 * Usage:
 * Can be triggered from within any component like so:
 *
 * import Toast from '../toast'
 * ...
 * this.$toast.success({
 *   component: Toast,
 *   props: {
 *    heading: 'This is a heading',
 *    body: 'This is a body'
 *   }
 * })
 *
 * Types: info (default style), success, error, warning
 * e.g. this.$toast.error({ ... })
 */
export default Vue.component(
  'toast',
  {
    props: [
      'heading',
      'body'
    ],
    computed: {
      iconType () {
        if (this.$parent.type === 'success') {
          return 'check'
        } else if (this.$parent.type === 'error' || this.$parent.type === 'warning') {
          return 'hazard'
        } else {
          return 'info'
        }
      }
    },
    template: `
      <div class="c-toast" :class="'c-toast--' + this.$parent.type">
        <svg class="c-icon c-toast__icon">
          <use :xlink:href="'/_resources/themes/default/images/icons/icons.svg#' + this.iconType"></use>
        </svg>
        <div class="c-toast__content">
          <h3 v-if="heading" class="c-toast__heading">{{heading}}</h3>
          <p v-if="body" class="c-toast__body" v-html="body"></p>
        </div>
        <button class="c-toast__close-btn" @click="$emit('close-toast')">
          <svg class="c-icon">
            <use xlink:href="/_resources/themes/default/images/icons/icons.svg#cross"></use>
          </svg>
        </button>
      </div>
    `
  }
)
